export default __webpack_public_path__ + "static/media/1.b9165ce3.jpg";